/** @typedef {import("../../types").StateVisualizacao} StateVisualizacao */
/** @typedef {import("../../types").OcorrenciaSelecionada} OcorrenciaSelecionada */

/**
 * Mutações do módulo relatoOcorrencia/visualizacao.
 * Gerencia o estado da ocorrência selecionada para visualização.
 */
export default {
  /**
   * Define a ocorrência selecionada no estado.
   * @param {StateVisualizacao} state
   * @param {OcorrenciaSelecionada} ocorrencia - item selecionado no grid
   */
  SET_OCORRENCIA_SELECIONADA(state, ocorrencia) {
    state.ocorrenciaSelecionada = ocorrencia;
  },

  /**
   * Limpa a ocorrência selecionada (usado ao sair da tela de visualização).
   * @param {StateVisualizacao} state
   */
  LIMPAR_OCORRENCIA_SELECIONADA(state) {
    state.ocorrenciaSelecionada = null;
  }
};